if($('svg #ring').length){
	TweenLite.defaultEase = Linear.easeNone;

	var controller = new ScrollMagic.Controller();
	var tl = new TimelineMax();
	tl.to('svg #ring', 1, {x:'-=20', rotation:180, transformOrigin:"50% 50%"});

	var scene = new ScrollMagic.Scene({
		duration: "100%",
		triggerHook: 0.25
	}).setTween(tl).addTo(controller);
}
